import InvoiceAppointment from "./InvoiceAppointment";

export default InvoiceAppointment;
